/*!
 * Copyright 2017 - 2020 by ChartIQ, Inc.
 * All rights reserved.
 */

import { Logger } from "../../../clients/logger";
import { RouterClient } from "../../../clients/routerClient";
import { BootTaskCallbackInterface } from "../types";
import { System } from "../../../common/system";
import { ConfigClient } from "../../../clients/configClient";
import { toast } from "../../../common/toast";

/**
 * Boot task that sets up the "Finsemble" wildcard pubsub for use throughout Finsemble.
 * @private
 */
export class WaitForUpdateDownloadTask {
	public async start(doneCallback: BootTaskCallbackInterface) {
		Logger.system.debug("waitForUpdateDownloadTask start");

		// Check configuration to see whether to wait for download.
		const { data: waitForUpdate } = await ConfigClient.getValue({
			field: "finsemble.waitForUpdate",
		});
		if (waitForUpdate) {
			System.getUpdateAvailable((isUpdateAvailable) => {
				if (isUpdateAvailable) {
					Logger.system.debug("Waiting for update to download");
					toast(
						"alert",
						"ONCE-SINCE-STARTUP",
						"Waiting for download",
						"Update available. Waiting for it to download before starting."
					);
					System.addEventListener("apply-update-requested", () => {
						Logger.system.debug("Update downloaded... restarting");
						/**
						 * forceRestart:true because the mechanism for a graceful shutdown has not been setup by this
						 * point as boot is not complete. Meaning a promise never returns and the system hangs forever.
						 * (servicesHaveShutdown() in shutDownManager never gets called)
						 *
						 * Additionally this "apply-update-requested" conflicts with the same event in the
						 * shutDownManager (constantly tries to spawn yes/no dialogs)
						 */
						RouterClient.transmit("Application.restart", { forceRestart: true });
					});
				} else {
					Logger.system.debug("Update not available... continue startup");
					doneCallback("waitForUpdateDownloadTask", "bootTasks", "completed");
				}
			});
		} else {
			Logger.system.debug("Starting without waiting for update to download");
			doneCallback("waitForUpdateDownloadTask", "bootTasks", "completed");
		}
	}
}
